export const draggableItemStyles = {
  listItem: (theme, isDragging) => ({
    opacity: isDragging ? 0.5 : 1,
    p: theme.spacing(1),
    borderRadius: theme.shape.borderRadius,
    transition: "background-color 0.2s, opacity 0.2s",
    backgroundColor: isDragging ? theme.palette.action.hover : "transparent",
    width: "100%",
  }),
  container: {
    display: "flex",
    alignItems: "center",
    width: "100%",
    gap: 1,
  },
  dragHandle: (theme) => ({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: "100%",
    cursor: "grab",
    color: theme.palette.text.secondary,
    marginRight: 0.5,
  }),
  contentBox: {
    flexGrow: 1,
    width: "calc(100% - 40px)",
  },
  deleteButtonBox: {
    display: "flex",
    alignItems: "center",
    ml: 1,
  },
  dragIcon: (isMobile) => ({
    fontSize: isMobile ? 24 : 20,
  }),
  deleteIcon: (theme) => ({
    color: theme.palette.error.main,
  }),
};

export const draggableListStyles = {
  list: {
    width: "100%",
    p: 0,
    m: 0,
  },
  addButton: {
    p: 0,
    m: 0,
  },
  inputContainer: {
    width: "100%",
  },
};
